module.exports = __webpack_public_path__ + "img/bg-proyectos-6.ff6ab92c.png";